<template>
  <div>
    <div v-if="this.btnSpinDocumentLog === false">
      <v-btn :color="ui.bkgdColor" @click="getDocumentLogList()"
              icon v-if="data.size == 'icon'">
        <v-icon :color="ui.btnColor"> history </v-icon>
      </v-btn>
      <v-btn :color="ui.btnColor" @click="getDocumentLogList()"
              flat v-if="data.size == 'flat'">
        <v-icon left> history </v-icon>
        Log
      </v-btn>
    </div>
    <div v-else>
      <BtnSpin v-if="data.size == 'icon'" :btnSpec="btnInfo1"/>
      <BtnSpin v-if="data.size == 'flat'" :btnSpec="btnInfo2"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";

export default {
  mixins: [apptheme, getList, dataSources, docLogFunctions],
  methods: {
    getDocumentLogList() {
      // GET Document List
      this.btnSpinDocumentLog = true;
      let tag = this.prepareForDocumentLog();
      // console.log("DOC PREPARE");
      // console.log(tag);
      let store = this.defineStore("D3");
      let router = this.defineRouter("D3");
      let db = this.defineDataSourceFromTagForRelationship("D3", tag);
      let sort = "NewestFirst";
      let order = "basic.did";
      this.getListDirect(db, order, sort, store, router);
    }
  },
  components: {
    BtnSpin
  },
  computed: {
    ...mapGetters(["getDetail", "getCurrentPage", "getUser"])
  },
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      valid: false,
      btnSpinDocumentLog: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "icon"
      },
      btnInfo2: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "flat"
      }
    };
  }
};
</script>
